import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { PourDropdownRespSuccess } from '../types';
import { useAppContext } from '@contexts/app';

export const usePourMethodsDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isFetching } = useQuery<PourDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.pourMethods,
    queryFn: () => queryFetch({ url: 'dropdowns/concrete_direct_pour_methods' }),
    placeholderData: (previousData) => previousData as PourDropdownRespSuccess,
    enabled,
  });

  return {
    data,
    error,
    isLoading: isFetching,
  };
};
